/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useToken } from "./useToken";
import { Link } from "react-router-dom";
import Nav from "./Navigation.js";
import { ChevronDown } from "lucide-react";

export default function SignUp() {
  const [username, setUsername] = useState("");
  const [discord_name, setDiscord_name] = useState("");
  const [visible, setVisible] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [password, setPassword] = useState("");
  const [languageId, setLanguageId] = useState(1);
  const [languages, setLanguages] = useState([]);
  const { signup } = useToken();
  const navigate = useNavigate();
  const [signupError, setSignupError] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/languages`)
      .then((res) => (res.ok ? res.json() : []))
      .then(setLanguages)
      .catch((err) => console.error("Error fetching languages:", err.message));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSignupError(""); // clear any old error
    try {
      await signup(
        username,
        discord_name,
        visible,
        question,
        answer,
        password,
        languageId
      );
      localStorage.setItem("username", username);
      navigate("/");
    } catch (e) {
      console.error("Signup error:", e.message);
      setSignupError("Username Already taken");
    }
  };


  const handleToggle = () => {
    setVisible(!visible);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
    const handleDiscord_nameChange = (event) => {
    setDiscord_name(event.target.value);
  };
    const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };
    const handleAnswerChange = (event) => {
    setAnswer(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const inputClass =
    "w-full bg-black/40 border border-purple-800/60 rounded-lg px-3 py-2 sm:px-4 sm:py-3 sm:text-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500";
  const labelClass = "block text-sm sm:text-base text-purple-200 font-medium mb-1";

  return (
    <div className="relative min-h-screen">
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 600px at 82% -8%, rgba(147,51,234,0.16), transparent 60%), " +
            "radial-gradient(1000px 700px at 8% 110%, rgba(88,28,135,0.22), transparent 60%), " +
            "#000",
        }}
      />
      <Nav />
      <div className="flex justify-center px-4 py-10">
        <div className="w-full max-w-md sm:max-w-lg md:max-w-xl">
          <div className="text-center font-primary text-3xl sm:text-4xl md:text-5xl text-white mb-6 sm:mb-8">
            Create an Account
          </div>

          <div className="bg-purple-950/20 border border-purple-800/60 rounded-lg p-6 sm:p-8 md:p-10">
            <form onSubmit={handleSubmit} className="flex flex-col gap-4 sm:gap-5">
              {signupError && (
                <div className="text-red-400 text-sm sm:text-base font-semibold text-center">
                  {signupError}
                </div>
              )}

              <div>
                <label className={labelClass}>Username</label>
                <input
                  onChange={handleUsernameChange}
                  value={username}
                  placeholder="Username"
                  required
                  type="text"
                  name="username"
                  id="username"
                  className={inputClass}
                />
              </div>

              <div>
                <label className={labelClass}>
                  Discord Name (type None if you do not wish to share)
                </label>
                <input
                  onChange={handleDiscord_nameChange}
                  value={discord_name}
                  placeholder="Discord Name"
                  required
                  type="text"
                  name="discord_name"
                  id="discord_name"
                  className={inputClass}
                />
              </div>

              <label className="flex items-center gap-2 text-sm sm:text-base text-gray-300">
                <input
                  type="checkbox"
                  checked={visible}
                  onChange={handleToggle}
                  className="h-4 w-4 accent-purple-600"
                />
                I want my added friends to see my Discord name
              </label>

              <div>
                <label className={labelClass}>Security Question</label>
                <p className="text-xs sm:text-sm text-gray-400 mb-2">
                  Discord Name and security question used for authentication/change requests
                </p>
                <input
                  onChange={handleQuestionChange}
                  value={question}
                  placeholder="Question"
                  required
                  type="text"
                  name="question"
                  id="question"
                  className={`${inputClass} mb-3`}
                />
                <input
                  onChange={handleAnswerChange}
                  value={answer}
                  placeholder="Answer"
                  required
                  type="text"
                  name="answer"
                  id="answer"
                  className={inputClass}
                />
              </div>

              <div>
                <label className={labelClass}>Preferred Language</label>
                <div className="relative">
                  <select
                    id="language"
                    name="language"
                    value={languageId}
                    onChange={(e) => setLanguageId(Number(e.target.value))}
                    className={`${inputClass} appearance-none pr-8 cursor-pointer`}
                  >
                    {languages.map((language) => (
                      <option key={language.id} value={language.id} className="bg-gray-900">
                        {language.name}
                      </option>
                    ))}
                  </select>
                  <ChevronDown
                    size={16}
                    className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                  />
                </div>
              </div>

              <div>
                <label className={labelClass}>Password</label>
                <input
                  onChange={handlePasswordChange}
                  value={password}
                  placeholder="Password"
                  required
                  type="password"
                  name="password"
                  id="password"
                  className={inputClass}
                />
                <p className="text-xs sm:text-sm text-gray-400 italic mt-1">
                  (Do not use a password you use on any other account)
                </p>
              </div>

              <p className="text-xs sm:text-sm text-gray-400">
                Although there are security measures for your protection, this is still a simple program.
              </p>

              <button
                type="submit"
                className="bg-purple-700 hover:bg-purple-600 transition-colors text-white font-semibold py-2.5 sm:py-3 sm:text-lg rounded-lg"
              >
                Sign Up
              </button>

              <p className="text-center text-gray-400 text-xs sm:text-sm">
                Already have an account?{" "}
                <Link className="text-purple-400 hover:text-purple-300" to="/login">
                  Login
                </Link>
              </p>
            </form>
          </div>

          <p className="text-center text-gray-500 text-xs sm:text-sm mt-4">
            &copy;2030 Shanda LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
